import { useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Layout from "../components/Layout";
import AssociationFiche from "../components/AssociationFiche";

// Page FORMATION ambassadeur — contenu pédagogique d'une association.
// Iter-31 — Le corps de la fiche vit désormais dans <AssociationFiche /> pour
// être réutilisé dans le backoffice partenaire (onglet "Vue ambassadeur").
// La couche premium (hero/branding, gratitude, impact stories) vit dans une page
// dédiée /espace-partenaires/:id pour ne pas mélanger formation et communication.
export default function Association() {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const initialTab = searchParams.get("tab") || "news";
    const [header, setHeader] = useState({ title: "Association", subtitle: "" });

    return (
        <Layout title={header.title} subtitle={header.subtitle}>
            <Link
                to="/associations"
                className="inline-flex items-center gap-2 text-white/60 hover:text-shariti-orange text-sm font-bold mb-4 transition-colors"
                data-testid="back-to-associations"
            >
                <ArrowLeft className="w-4 h-4" />
                Toutes les associations
            </Link>

            <div className="mt-6">
                <AssociationFiche
                    associationId={id}
                    initialTab={initialTab}
                    onLoaded={(d) =>
                        setHeader({ title: d.name, subtitle: d.short_description || "" })
                    }
                />
            </div>
        </Layout>
    );
}
